const menus = [
  {
    enName: 'Home',
    href: '/home',
    code: 'HOME',
    icon: 'iconDashboard',
  },
  {
    enName: 'Editorial Office',
    href: '/editorial-office',
    unClick: true,
    code: 'EDITOR_TASK',
    icon: 'icona-Editortask',
    children: [
      {
        enName: 'Manuscripts',
        href: '/editorial-office/manuscripts',
        code: 'EDITOR_TASK.MANUSCRIPTS',
        children: [
          {
            enName: 'Correspondence Record',
            href: '/editorial-office/manuscripts/corespondence-record',
          },
          {
            enName: 'Details',
            href: '/editorial-office/manuscripts/details',
            // children: [
            //   {
            //     enName: 'Other Author',
            //     href: '/editorial-office/manuscripts/details/other-author'
            //   }
            // ]
          },
        ],
      },
      {
        enName: 'Manage Volunteers',
        href: '/editorial-office/manage-volunteers',
        code: 'EDITOR_TASK.MANAGE_VOLUNTEER',
      },
      {
        enName: 'Subscribe',
        href: '/publishing/subscribe',
        code: 'EDITOR_TASK.SUBSCRIPTION',
      },
      {
        enName: 'Discount Voucher',
        href: '/editorial-office/discount-voucher',
        code: 'EDITOR_TASK.DISCOUNT_VOUCHER ',
      },
    ],
  },
  {
    enName: 'Authors',
    href: '/author',
    unClick: true,
    code: 'SUBMISSIONS_MENU',
    icon: 'icona-SubmissionMenu',
    children: [
      {
        enName: 'New Submission',
        href: '/author/submit-manuscripts',
        redirect: '/author/submit-manuscripts/step1',
        code: 'SUBMISSIONS_MENU.NEW_SUBMISSION',
      },
      {
        enName: 'Submitted Manuscripts',
        href: '/author/submitted-manuscripts',
        code: 'SUBMISSIONS_MENU.SUBMITTED_MANUSCRIPTS',
      },
      {
        enName: 'Co-author Manuscripts',
        href: '/author/co-author-manuscripts',
        code: 'SUBMISSIONS_MENU.COAUTHOR_MANUSCRIPTS',
      },
      // {
      //   enName: 'Review Report',
      //   href: '/author/submitted-review/report'
      // },
      // {
      //   enName: 'Editorial Decisions',
      //   href: '/editorial-office/manuscripts/decisions-editorial'
      // },
      // {
      //   enName: 'View The Decisions',
      //   href: '/author/submitted-view/decisions'
      // }
      // {
      //   enName: 'Review Report',
      //   href: '/author/submitted-review/report'
      // },
      // {
      //   enName: 'Editorial Decisions',
      //   href: '/editorial-office/manuscripts/decisions-editorial'
      // },
      // {
      //   enName: 'View The Decisions',
      //   href: '/author/submitted-view/decisions'
      // }
    ],
  },
  {
    enName: 'Reviewers',
    href: '/reviewers-menu',
    unClick: true,
    code: 'REVIEWERS_MENU',
    icon: 'icona-ReviewersMenu',
    children: [
      {
        enName: 'Volunteer Application',
        $unrole: 'REVIEWER',
        href: '/reviewers-menu/volunteer',
      },
      {
        enName: 'Reviews',
        $role: 'REVIEWER',
        href: '/reviewers-menu/reviews',
        // children: [
        //   {
        //     enName: 'User Profile',
        //     // href: '/user-manage/manage-employees/:id',
        //     href: '/reviewers-menu/reviews/reviews-detail'
        //     // isDetail: true
        //   }
        // ]
      },
    ],
  },
  {
    enName: 'Academic Editors',
    href: '/academic-editor',
    unClick: true,
    code: 'ACADEMIC_EDITOR_MENU',
    icon: 'icona-AcdamicEditor',
    children: [
      {
        enName: 'Reviews',
        href: '/academic-menu/academic',
        code: 'ACADEMIC_EDITOR_MENU.REVIEWS',
      },
      // {
      //   enName: 'Manuscripts',
      //   href: '/academic-menu/manuscripts',
      //   code: 'ACADEMIC_EDITOR_MENU.MANUSCRIPTS'
      // }
    ],
  },
  {
    enName: 'User Management',
    href: '/user-manage',
    unClick: true,
    code: 'USER_MANAGE',
    icon: 'icona-UserManage',
    children: [
      {
        enName: 'Manage Employees',
        href: '/user-manage/manage-employees',
        code: 'USER_MANAGE.MANAGE_EMPLOYEES',
        children: [
          {
            enName: 'User Profile',
            href: '/user-manage/manage-employees/:id',
            isDetail: true,
          },
        ],
      },
      {
        enName: 'Manage Users',
        href: '/user-manage/manage-users',
        code: 'USER_MANAGE.MANAGE_USERS',
        children: [
          {
            enName: 'User Profile',
            href: '/user-manage/manage-users/:id',
            isDetail: true,
          },
        ],
      },
    ],
  },
  {
    enName: 'Publishing',
    href: '/publishing',
    unClick: true,
    code: 'WEBSITE',
    icon: 'icona-ForReviewers',
    children: [
      {
        enName: 'Publication',
        href: '/publishing/publication',
        code: 'WEBSITE.PUBLISHING',
        children: [
          {
            enName: 'Add New Article',
            href: '/publishing/publication/add',
          },
        ],
      },
      {
        enName: 'Volume & Issue',
        href: '/publishing/volume-issue',
        code: 'WEBSITE.VOLUME_ISSUE',
        children: [
          {
            enName: 'Articles',
            href: '/publishing/volume-issue/articles',
          },
        ],
      },
      {
        enName: 'Journals',
        href: '/publishing/journals',
        code: 'WEBSITE.JOURNALS',
        children: [
          {
            enName: 'Add Journals',
            href: '/publishing/journals/add',
          },
        ],
      },

      {
        enName: 'Journal Website',
        href: '/publishing/journal-website',
        code: 'WEBSITE.JOURNAL_WEBSITE',
      },
      {
        enName: 'Editorial Board',
        href: '/publishing/editorial-board',
        code: 'WEBSITE.EDITOR_BOARD',
        children: [
          {
            enName: 'Editorial Board Application',
            href: '/publishing/editorial-board/application',
          },
        ],
      },
      {
        enName: 'Reviewer Board',
        href: '/publishing/reviewer-board',
        code: 'WEBSITE.REVIEWER_BOARD',
        children: [
          {
            enName: 'Reviewer Board Application',
            href: '/publishing/reviewer-board/application',
          },
        ],
      },
      {
        enName: 'Special Issues',
        href: '/publishing/special-issue',
        code: 'WEBSITE.SPECIAL_ISSUES',
        children: [
          {
            enName: 'Add Special Issues',
            href: '/publishing/special-issue/add',
          },
          {
            enName: 'Special Issues Application',
            href: '/publishing/special-issue/application',
          },
        ],
      },
      {
        enName: 'Topics',
        href: '/publishing/topics',
        code: 'WEBSITE.TOPICS',
        children: [
          {
            enName: 'Add Topic',
            href: '/publishing/topics/add',
          },
        ],
      },
    ],
  },
  {
    enName: 'System',
    href: '/system',
    unClick: true,
    code: 'SYSTEM',
    icon: 'iconSystem',
    children: [
      {
        enName: 'Publisher',
        href: '/system/publisher',
        // redirect: '/system/publisher/basic-information',
        code: 'SYSTEM.PUBLISH',
      },
      {
        enName: 'Manage Authority',
        href: '/system/manage-authority',
        code: 'SYSTEM.STRUCTURE_AUTHORITY',
      },
      {
        enName: 'Manage Email',
        href: '/system/manage-email',
        // redirect: '/system/manage-email/email-template',
        code: 'SYSTEM.MAIL',
        children: [
          {
            enName: 'Email Template',
            href: '/system/manage-email/email-template',
          },
          {
            enName: 'Actions',
            href: '/system/manage-email/actions',
          },
          {
            enName: 'Email Signature',
            href: '/system/manage-email/email-signature',
          },
          {
            enName: 'Email Address',
            href: '/system/manage-email/email-address',
          },
          {
            enName: 'Checklist',
            href: '/system/manage-email/checklist',
          },
          {
            enName: 'Records',
            href: '/system/manage-email/records',
          },
        ],
      },
      {
        enName: 'Manage Questionnaire',
        href: '/system/manage-questionnaire',
        code: 'SYSTEM.QUESTIONNAIRE_MANAGE',
        children: [
          {
            enName: 'Add Question',
            href: '/system/manage-questionnaire/add',
          },
          {
            enName: 'Edit Question',
            href: '/system/manage-questionnaire/edit',
          },
        ],
      },
      {
        enName: 'Operation Record',
        href: '/system/operation-record',
        code: 'SYSTEM.OPERATION_RECORD',
      },
      {
        enName: 'Content Setting',
        href: '/system/content-setting',
        code: 'SYSTEM.CONTENT_SETTING',
      },
      {
        enName: 'Journal Setting',
        href: '/system/journal-setting',
        code: 'SYSTEM.JOURNAL_SETTING',
        children: [
          {
            enName: 'General Setting',
            href: '/system/journal-setting/general-setting',
          },
          {
            enName: 'Country Setting',
            href: '/system/journal-setting/country-setting',
          },
          {
            enName: 'Article Type Setting',
            href: '/system/journal-setting/article-type-setting',
          },
        ],
      },
      {
        enName: 'Publisher Setting',
        href: '/system/dictpublisher-setting',
        code: 'SYSTEM.PUBLISHER_SETTING',
        children: [
          {
            enName: 'General Setting',
            href: '/system/dictpublisher-setting/general-setting',
          },
          {
            enName: 'Country Setting',
            href: '/system/dictpublisher-setting/country-setting',
          },
          {
            enName: 'Article Type Setting',
            href: '/system/dictpublisher-setting/article-type-setting',
          },
        ],
      },
    ],
  },
  {
    enName: 'Statistics',
    href: '/statistic',
    code: 'STATISTICS',
    icon: 'iconStatistics-01',
    children: [
      {
        enName: 'Graphical Analysis',
        href: '/statistic/graphic',
        code: 'STATISTICS.GRAPHICAL_ANALYSIS',
      },
      {
        enName: 'Data Report',
        href: '/statistic/data',
        code: 'STATISTICS.DATA_REPORT',
      },
    ],
  },
]

export default menus
